import { makeStyles } from '@fluentui/react-components';

export const useToolbarStyles = makeStyles({
    toolbar: {
        padding: 0,
        marginTop: '1em',
        zIndex: 2,
    },
    toolbarGroup: {
        display: 'flex',
        // flexGrow: 1,
        flexWrap: 'nowrap',
        // overflow: 'auto'
    },
    /*toolbarGroupOverflow: {
        display: 'flex',
        flexGrow: 1,
        flexWrap: 'nowrap',
        overflow: 'auto'
    }*/
});
